<div class="card">
    <div class="card-header text-primary"><h1 class="m-0 float-left">Servicios</h1></div>
    <div class="card-body">

        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

            <div class="row">
                <div class="col-lg-12">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" formControlName="name">
                    <div *ngIf="isFieldInvalid('name')" class="error-input">
                        <div *ngIf="form.get('name')?.errors?.['required']">Campo requerido</div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-lg-12">
                    <label for="name" class="form-label">Value</label>
                    <input type="number" class="form-control" id="value" formControlName="value">
                    <div *ngIf="isFieldInvalid('value')" class="error-input">
                        <div *ngIf="form.get('value')?.errors?.['required']">Campo requerido</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="status" formControlName="status">
                    <label for="status" class="form-label">Estado</label>
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-lg-12">
                    <button [disabled]="form.invalid" class="btn btn-primary btn-sm m-1" type="submit">{{ (id) ? 'Actualizar' : 'Guardar' }}</button>
                    <button class="btn btn-info btn-sm m-1" type="button" routerLink="/categories">Cancelar</button>
                </div>
            </div>

        </form>

    </div>
</div>